import React from "react";
import { Link } from "react-router-dom";
import Helmet from "react-helmet";
import Jumbotron from "../components/Jumbotron";
import styles from "../styles/contact.module.scss";
import mapImage from "../images/mapofcampus.jpg";
import featuredImage from "../images/research/transepi_featured.jpg";
import Img from "gatsby-image";
import PageWrapper from "../components/PageWrapper";

import {
	withScriptjs,
	withGoogleMap,
	GoogleMap,
	Marker
} from "react-google-maps";

function createMarkup(content) {
	return { __html: content };
}
const Contact = ({ data, transition, location }) => {
	const { pageSettings, faqList } = data;
	const contactDetails = data.contactDetails.edges[0].node;
	const poc = contactDetails.pointsOfContact;

	return (
		<PageWrapper locale={pageSettings.node_locale} location={location} data={data.layout.edges[0].node}>
			<main role="main" style={transition && transition.style}>
				<Helmet title={pageSettings.pageTitle + " | Mahidol Vivax Research Unit"} />
	
				<Jumbotron
					bottomLine={true}
					type="jumbotron_b"
					className="mb-0"
					textAlign="text-center"
					contentAlign="justify-content-md-center"
				>
					<h1>{pageSettings.pageTitle}</h1>
				</Jumbotron>
	
				<div className="container">
					<div className="row justify-content-start">
						{poc &&
							poc.length > 0 &&
							poc.map((item, i) => {
								return (
									<div
										key={"poc-" + i}
										className={
											"col-12 col-sm-6 col-lg-4 " + styles.contact_category
										}
									>
										<div style={{ margin: "0 auto" }}>
											<h3
												style={{
													width: "14rem",
													margin: "0 auto"
												}}
											>
												{item.title}
											</h3>
											<span>
												<i className="phone" />
												Phone​ {item.phone}
											</span>
											<span>
												<i className="envelope" />
												{item.email}
											</span>
											<hr className={styles.hr_short} />
										</div>
									</div>
								);
							})}
					</div>
	
					<hr className={styles.hr_long} style={{ marginTop: "1rem" }} />
					<div className="row justify-content-between">
						<div className="col-12 col-md-6 col-lg-8 mb-5">
							{pageSettings.node_locale !== "th" && (
								<span
									dangerouslySetInnerHTML={createMarkup(
										contactDetails.postalAddress.content.html
									)}
								/>
							)}
	
							<br />
							<br />
							<span
								dangerouslySetInnerHTML={createMarkup(
									contactDetails.postalAddressTh.content.html
								)}
							/>
	
							<a href={contactDetails.googleMapsUrl} target="_blank">
								Get directions on Google Maps &raquo;{" "}
							</a>
						</div>
	
						<div className={"col-12 col-md-6  col-lg-4  mb-5 " + styles.questions_wrapper}>
							<div className={styles.questions}>
								<h3>FAQ</h3>
								<ul className="list-unstyled">
									{faqList.edges &&
										faqList.edges.length > 0 &&
										faqList.edges.map(({ node }, i) => {
											return (
												<li
													key={"question-" + i}
													className={styles.question_link}
												>
													<Link
														to={
															"/" +
															pageSettings.node_locale +
															"/faq#" +
															node.slug
														}
													>
														<span>{node.question}</span>
														<i />
													</Link>
												</li>
											);
										})}
								</ul>
							</div>
						</div>
					</div>
				</div>
	
				<div className="row m-0">
					<div className="col-12 col-lg-6" style={{ margin: "0", padding: "0" }}>
						<MyMapComponent
							lat={parseFloat(contactDetails.location.lat)}
							lng={parseFloat(contactDetails.location.lon)}
							zoom={parseInt(17, 9)}
							isMarkerShown
							googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDmvpaL6fTOgzkaoOicsxLKKBl3Ju9iPio&v=3.exp&libraries=geometry,drawing,places"
							loadingElement={<div style={{ height: `100%` }} />}
							containerElement={
								<div className={styles.map_wrapper_height} />
							}
							mapElement={<div style={{ height: `100%` }} />}
						/>
					</div>
					<div className="col-12 col-lg-6" style={{ padding: "0" }}>
						<Img
							title={contactDetails.mapImage.title}
							alt={contactDetails.mapImage.title}
							sizes={contactDetails.mapImage.sizes}
						/>
					</div>
				</div>
			</main>
		</PageWrapper>
	);
};

export default Contact;

const MyMapComponent = withScriptjs(
	withGoogleMap(props => (
		<GoogleMap
			defaultZoom={props.zoom}
			defaultCenter={{ lat: props.lat, lng: props.lng }}
		>
			{props.isMarkerShown && (
				<Marker position={{ lat: props.lat, lng: props.lng }} />
			)}
		</GoogleMap>
	))
);

export const query = graphql`
	query ContactPageQuery($id: String!, $locale: String!) {
		layout: allMvruJson {
			edges {
				node {
					...layoutFields
				}
			}
		}


		pageSettings: contentfulContactPage(id: { eq: $id }) {
			pageTitle
			metaDescription {
				metaDescription
			}
			node_locale
		}

		contactDetails: allContentfulContact(
			filter: { node_locale: { eq: $locale } }
		) {
			edges {
				node {
					title
					postalAddress {
						content: childMarkdownRemark {
							html
						}
					}
					postalAddressTh {
						content: childMarkdownRemark {
							html
						}
					}
					googleMapsUrl
					location {
						lon
						lat
					}
					pointsOfContact {
						title
						phone
						email
					}
					mapImage {
						title
						sizes {
							base64
							aspectRatio
							src
							srcSet
							srcWebp
							srcSetWebp
							sizes
						}
					}
					node_locale
				}
			}
		}

		faqList: allContentfulFaq(filter: { node_locale: { eq: $locale } }) {
			edges {
				node {
					id
					slug
					question
					node_locale
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/templates/contact-template.js